import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class RouteTrackerService {
    constructor() {
        
    }
    
    private _routeHistory: string[] = [];
    
    public addRouteToHistory(route: string) {
        if (route && route != this.currentRoute) {
            this._routeHistory.push(route);
        }
    }
    
    public clearRouteHistory() {
        this._routeHistory = [];
    }
    
    public getHistory() {
        return this._routeHistory;
    }
    
    public get currentRoute() {
        if (this._routeHistory) {
            return this._routeHistory[this._routeHistory.length - 1];
        }
        
        return "";
    }

    public get previousRoute() {
        if (this._routeHistory) {
            return this._routeHistory[this._routeHistory.length - 2];
        }

        return "";
    }
}